module.exports = __webpack_public_path__ + "img/img1.f1f261c0.jpg";